import FormUsuario from 'components/public/FormUsuario/FormUsuario';
import { UsuarioDTO } from 'utils/models/types';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import { Box } from '@mui/material';

const Registro = () => {
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: UsuarioDTO = usuarioJSON && JSON.parse(usuarioJSON);
  const esAdmin = usuario?.Rol === 'Administrador';
  const variante = esAdmin ? 'registroUsuDesdeAdmin' : 'registroUsu';

  return (
    <DashboardContainer>
      <Box mb={usuario ? '' : '280px'}>
        <FormUsuario titulo="Registro" variante={variante} textoBoton="Registrarse" />
      </Box>
    </DashboardContainer>
  );
};

export default Registro;
